const reportWebVitals = (onPerfEntry, importer) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    const load = importer || (() => import('web-vitals'));
    return load().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
  return undefined;
};

export default reportWebVitals;
